import Vue from 'vue'

import * as analyticsUtils from '../utils/Analytics'
import * as arrayUtils from '../utils/Arrays'
import * as cookieUtils from '../utils/Cookies'
import * as windowUtils from '../utils/Window'

import Anchor from '@/components/Anchor'
import Button from '@/components/Button'
import Container from '@/components/Container'
import IconBase from '@/components/IconBase'
// TODO: RouteTo would be used exclusively to utilize vue router
// import RouteTo from '@/components/RouteTo'
import ScheduledContent from '@/components/ScheduledContent'

const Plugin = {}

const custom = Plugin.install = function (Vue, options) {
  Vue.component('anchor', Anchor)
  Vue.component('cta-button', Button)
  Vue.component('container', Container)
  Vue.component('icon', IconBase)
  // Vue.component('route-to', RouteTo)
  Vue.component('scheduled-content', ScheduledContent)

  Vue.mixin({
    methods: {
      ...analyticsUtils,
      ...arrayUtils,
      ...cookieUtils,
      ...windowUtils
    }
  })
}

Vue.use(custom)
